import type { SubdivisionCatalog } from "./types";

/**
 * Brazil — 26 states plus the Distrito Federal.
 *
 * Every row carries its UF as an alias. In Brazil the two-letter UF is the everyday form on any address
 * (Correios, invoices, banks) and it happens to be exactly the ISO 3166-2 suffix, so a user typing "SP"
 * expects São Paulo to appear. It stays an alias and never becomes the submitted value: the product decision
 * is one uniform representation across the six countries, and that representation is the name.
 */
export const BRA_SUBDIVISIONS: SubdivisionCatalog = [
  { code: "BR-AC", name: "Acre", aliases: ["AC"] },
  { code: "BR-AL", name: "Alagoas", aliases: ["AL"] },
  { code: "BR-AP", name: "Amapá", aliases: ["AP"] },
  { code: "BR-AM", name: "Amazonas", aliases: ["AM"] },
  { code: "BR-BA", name: "Bahia", aliases: ["BA"] },
  { code: "BR-CE", name: "Ceará", aliases: ["CE"] },
  { code: "BR-DF", name: "Distrito Federal", aliases: ["DF"] },
  { code: "BR-ES", name: "Espírito Santo", aliases: ["ES"] },
  { code: "BR-GO", name: "Goiás", aliases: ["GO"] },
  { code: "BR-MA", name: "Maranhão", aliases: ["MA"] },
  { code: "BR-MT", name: "Mato Grosso", aliases: ["MT"] },
  { code: "BR-MS", name: "Mato Grosso do Sul", aliases: ["MS"] },
  { code: "BR-MG", name: "Minas Gerais", aliases: ["MG"] },
  { code: "BR-PA", name: "Pará", aliases: ["PA"] },
  { code: "BR-PB", name: "Paraíba", aliases: ["PB"] },
  { code: "BR-PR", name: "Paraná", aliases: ["PR"] },
  { code: "BR-PE", name: "Pernambuco", aliases: ["PE"] },
  { code: "BR-PI", name: "Piauí", aliases: ["PI"] },
  { code: "BR-RJ", name: "Rio de Janeiro", aliases: ["RJ"] },
  { code: "BR-RN", name: "Rio Grande do Norte", aliases: ["RN"] },
  { code: "BR-RS", name: "Rio Grande do Sul", aliases: ["RS"] },
  { code: "BR-RO", name: "Rondônia", aliases: ["RO"] },
  { code: "BR-RR", name: "Roraima", aliases: ["RR"] },
  { code: "BR-SC", name: "Santa Catarina", aliases: ["SC"] },
  { code: "BR-SP", name: "São Paulo", aliases: ["SP"] },
  { code: "BR-SE", name: "Sergipe", aliases: ["SE"] },
  { code: "BR-TO", name: "Tocantins", aliases: ["TO"] },
];
